import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

const MENU_SET_NOT_DELETABLE_ERROR_NAME = 'MenuSetNotDeletableError';

export const isMenuSetNotDeletableError = (err: unknown): err is Error =>
  err instanceof Error && err.name === MENU_SET_NOT_DELETABLE_ERROR_NAME;

export const deleteMenuSet = async (menuSetId: string, dryRun?: boolean): Promise<void> => {
  const query = dryRun ? '?dryRun=true' : '';
  const res = await fetch(`${API_URL}/menus/menu-sets/${menuSetId}${query}`, {
    method: 'DELETE',
  });

  if (res.status === Status.BAD_REQUEST || res.status === Status.NOT_FOUND) {
    const message = await res
      .json()
      .then((json) => json.message)
      .catch(() => 'Could not delete menu set');
    const error = new Error(message);
    error.name = MENU_SET_NOT_DELETABLE_ERROR_NAME;
    throw error;
  }

  if (!res.ok) {
    throw new Error('Could not delete menu set');
  }
};

export const canDeleteMenuSet = (menuSetId: string): Promise<void> => deleteMenuSet(menuSetId, true);
